import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export const getEvBvReportDetails = async (body) => {
  const token = await getBearerToken();
  const response = await fetch(API_ENDPOINTS.GET_EV_BV_REPORT_DETAILS, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    return {
      hasError: true,
      response: response,
    };
  }
  const apiResponse = await response.json();
  return {
    hasError: false,
    response: apiResponse,
  };
};
